// extracted by mini-css-extract-plugin
export default {"root":"styles_root__4t2rr","root--checked":"styles_root--checked__p84WF","spin":"styles_spin__I+8VD"};